import { render, staticRenderFns } from "./InstallmentBatchTypeTable.vue?vue&type=template&id=61ddc6e1&"
import script from "./InstallmentBatchTypeTable.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports